import { includes, some, flow, map, curry, filter, get, negate, isEqual } from 'lodash/fp';
import cookiesFactory from '../../../base/cookies-factory';

// const hasSelectedInternalOptions = (item) => {
//  if (!item.itemProduct) {
//    return false;
//  }
//  const defaultInternalSelections = ['', 'No', 'Standard Width'];
//  const internalChoices = item.itemProduct.choices.filter(choice => choice.isInternal);
//  return internalChoices.some(choice =>
//    !includes(defaultInternalSelections, choice.choiceValue));
// };
const hasSelectedInternalOptions = (item) => {
  const defaultInternalSelections = ['', 'No', 'Standard Width'];

  return flow(
    get('itemProduct.choices'),
    filter('isInternal'),
    map('choiceValue'),
    some(negate(includes(curry.placeholder, defaultInternalSelections))),
  )(item);
};

const customCategory = flow(
  get('itemProduct.productType'),
  isEqual('Custom'),
);

export default item => !cookiesFactory.isInternalUser() &&
    (customCategory(item) || hasSelectedInternalOptions(item));
